import type { NormalizedEvent } from "@/services/types/agent-gateway";
import { FileText } from "lucide-react";
import { formatEventAuthor, formatEventTime } from "./event-utils";

type ArtifactEvent = Extract<NormalizedEvent, { type: "artifact" }>;

export function ArtifactCard({ event }: { event: ArtifactEvent }) {
  return (
    <article className="flex items-center gap-3 rounded-lg border border-slate-200 bg-white p-4">
      <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-slate-100">
        <FileText aria-hidden="true" className="size-5 text-slate-600" />
      </span>
      <div className="min-w-0 flex-1">
        <h3 className="font-medium text-sm [overflow-wrap:anywhere]">
          {event.content.label}
        </h3>
        <p className="mt-1 text-slate-500 text-xs [overflow-wrap:anywhere]">
          {event.content.mime_type} · {formatEventAuthor(event.author)} ·{" "}
          {formatEventTime(event.created_at)}
        </p>
      </div>
    </article>
  );
}
